import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import "./App.css";  
import Home from "./components/Home";
import ElegantBackground from "./common/bg/ElegantBackground";
import ProductHome from "./product/ProductHome";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route 
          path="/home" 
          element={
            <>
              <ElegantBackground />
              <Home />
            </>
          } 
        />
        <Route path="/" element={<ProductHome />} />
      </Routes>
    </Router>
  );
};

export default App;
